// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

window.addEventListener('load', () => {
  let blockProject = document.querySelectorAll('.projects-carousel')

  // configure Swiper to use modules
  Swiper.use([Navigation, Pagination, Autoplay])

  if (blockProject.length > 0) {
    blockProject.forEach(project => {
      const currentProjectSlide = project.querySelector('.current-slide')
      const totalProjectSlides = project.querySelector('.total-slide')
      const pagination = project.querySelector('.swiper-pagination')

      // init Swiper:
      let carousel = new Swiper('.projects-carousel', {
        loop: false,
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
          reverseDirection: false
        },
        watchOverflow: true,
        autoHeight: false,

        // bullets
        pagination: {
          el: pagination
        },

        // arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        runCallbacksOnInit: true,
        on: {
          init: function (el) {
            currentProjectSlide.innerHTML = el.activeIndex + 1
            totalProjectSlides.innerHTML = el.slides.length
          },
          slideChange: function (el) {
            currentProjectSlide.innerHTML = el.activeIndex + 1
            totalProjectSlides.innerHTML = el.slides.length
          }
        }
      })
    })
  }
})
